import React from 'react';
import './select.css';
import { useDispatch, useSelector } from "react-redux";
import { selectAction } from "../../redux/rootReducer";
import { SELECT_INITIAL } from "../../redux/initialStateConstant";

const Select = ({ current, type, options, handler, smart, cell, resetVisible, resetHandler }) => {
    const dispatch = useDispatch();

    const select = useSelector(state => state.select);

    // Фильтруем список значений, если smart = true и есть значение в инпуте
    let filteredOptions = () => {

        if (smart && select.current) {
            return options.filter(el => el.name?.toLowerCase().indexOf(select.current.toLowerCase()) + 1);
        }
        else {
            return options;
        }
    };

    return (
        <div className="slt">
            {
                smart
                ?
                    <div className={ `slt__current slt__current--input ${ cell ? 'slt__current--cell' : '' }` }
                         onClick={ () => select === type ? dispatch(selectAction(SELECT_INITIAL)) : dispatch(selectAction({ ...select, type: type })) }
                    >
                        <input type="text" className="slt__input"
                               value={ select.type === type && (select.current || select.current === '') ? select.current : current || '' }
                               onInput={ event => {
                                   dispatch(selectAction({ ...select, current: event.target.value }));
                               } }
                        />
                    </div>
                :
                    <div className="slt__current"
                         onClick={ () => select.type === type ? dispatch(selectAction(SELECT_INITIAL)) : dispatch(selectAction({ ...select, type })) }
                    >
                        { resetVisible ? <i className="slt__clear" onClick={ resetHandler } /> : false }
                        { current }
                    </div>
            }
            <div className={ `slt__items ${ select.type === type ? 'slt__items--open' : '' }` }>
                {
                    filteredOptions()?.map(elem => {
                        return (
                            <div className="slt__item" key={ elem.id }
                                onClick={ () => handler(elem) }
                            >
                                { elem.name }
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};

export default Select;